import useSWR from "swr";
import { getProticoClient } from "../utils/api";
import { useWeb3Auth } from "./useWeb3Auth";
const voucherFetcher = getProticoClient().engagement.getVoucherList;

const useVoucher = () => {
  const { address, isProticoAuthenticated } = useWeb3Auth();

  const { data, error } = useSWR(
    isProticoAuthenticated ? [`useVoucher-${address}`] : null,
    voucherFetcher,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  return {
    voucherList: data ?? [],
    isLoading: !error && !data,
    isError: error,
  };
};

export default useVoucher;
